import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-invoice-announcement-confirmation-table",
  templateUrl: "./invoice-announcement-confirmation-table.component.html",
  styleUrls: ["./invoice-announcement-confirmation-table.component.scss"],
})
export class InvoiceAnnouncementConfirmationTableComponent implements OnInit {
  @Input() invoices: any;
  @Input() withScroll = false;
  constructor() {}

  ngOnInit(): void {}

  getCodes(invoice: any) {
    return invoice.physicalInvoices.map((i: any) => i.code).join("\n");
  }
}
